const SOURCE_FNS_GIR_BO = 'https://www.nalog.gov.ru/rn77/bo/'
const SOURCE_FNS_2Q_2026 = 'https://www.nalog.gov.ru/html/sites/www.rn78.nalog.ru/Different/2026/%D0%A1%D1%80%D0%BE%D0%BA%D0%B8%20%D1%83%D0%BF%D0%BB.%20%D0%B8%20%D0%BF%D1%80%D0%B5%D0%B4%D1%81%D1%82%D0%B0%D0%B2%D0%BB.%20%D1%83%D0%B2%D0%B5%D0%B4%D0%BE%D0%BC%D0%BB%D0%B5%D0%BD%D0%B8%D0%B9%20%D0%B7%D0%B0%202%20%D0%BA%D0%B2.%202026.pdf'
const SOURCE_REGBERRY_2026 = 'https://www.regberry.ru/malyy-biznes/nalogovyj-kalendar'

const VERIFIED_AT = '2026-05-22'

const REPORTING_DEADLINES = [
  {
    title: 'Уведомление по НДФЛ',
    dueDate: '2026-06-03',
    period: '23-31 мая 2026',
    status: 'form_not_configured',
    routeName: 'reports_list',
    sourceName: 'ФНС: сроки уведомлений за 2 квартал 2026',
    sourceUrl: SOURCE_FNS_2Q_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Декларация по косвенным налогам при импорте из ЕАЭС',
    dueDate: '2026-06-22',
    period: 'май 2026',
    status: 'form_not_configured',
    routeName: 'reports_list',
    sourceName: 'Regberry: календарь бухгалтера 2026',
    sourceUrl: SOURCE_REGBERRY_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Уведомление по НДФЛ',
    dueDate: '2026-06-25',
    period: '1-22 июня 2026',
    status: 'form_not_configured',
    routeName: 'reports_list',
    sourceName: 'ФНС: сроки уведомлений за 2 квартал 2026',
    sourceUrl: SOURCE_FNS_2Q_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Уведомление по страховым взносам',
    dueDate: '2026-06-25',
    period: 'май 2026',
    status: 'form_not_configured',
    routeName: 'reports_list',
    sourceName: 'ФНС: сроки уведомлений за 2 квартал 2026',
    sourceUrl: SOURCE_FNS_2Q_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Расчет по страховым взносам',
    dueDate: '2026-07-27',
    period: 'полугодие 2026',
    status: 'form_not_configured',
    routeName: 'reports_list',
    sourceName: 'ФНС: сроки уведомлений за 2 квартал 2026',
    sourceUrl: SOURCE_FNS_2Q_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Декларация по НДС',
    dueDate: '2026-07-27',
    period: 'II квартал 2026',
    status: 'supported',
    routeName: 'reports_create_nds',
    sourceName: 'Regberry: календарь бухгалтера 2026',
    sourceUrl: SOURCE_REGBERRY_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Декларация по налогу на прибыль',
    dueDate: '2026-07-27',
    period: 'полугодие 2026',
    status: 'form_not_configured',
    routeName: 'reports_list',
    sourceName: 'Regberry: календарь бухгалтера 2026',
    sourceUrl: SOURCE_REGBERRY_2026,
    verifiedAt: VERIFIED_AT
  },
  {
    title: 'Бухгалтерская отчетность',
    dueDate: '2026-03-31',
    period: '2025 год',
    status: 'supported',
    routeName: 'reports_create_balance',
    sourceName: 'ФНС: ГИР БО',
    sourceUrl: SOURCE_FNS_GIR_BO,
    verifiedAt: VERIFIED_AT
  }
]

function parseDate(value) {
  const [year, month, day] = value.split('-').map((part) => parseInt(part, 10))
  return new Date(year, month - 1, day)
}

function startOfDay(value) {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate())
}

function addDays(value, days) {
  const next = new Date(value)
  next.setDate(next.getDate() + days)
  return next
}

export function getUpcomingReportingTasks(now = new Date(), options = {}) {
  const from = startOfDay(now)
  const until = addDays(from, options.daysAhead || 45)
  const year = options.year ? parseInt(options.year, 10) : null

  return REPORTING_DEADLINES
    .map((item) => ({
      ...item,
      due: parseDate(item.dueDate)
    }))
    .filter((item) => {
      if (year && item.due.getFullYear() !== year) {
        return false
      }
      return item.due >= from && item.due <= until
    })
    .sort((left, right) => left.due - right.due)
}

export function getReportingCalendarSources() {
  return [
    { name: 'ФНС: ГИР БО', url: SOURCE_FNS_GIR_BO, verifiedAt: VERIFIED_AT },
    { name: 'ФНС: сроки уведомлений за 2 квартал 2026', url: SOURCE_FNS_2Q_2026, verifiedAt: VERIFIED_AT },
    { name: 'Regberry: календарь бухгалтера 2026', url: SOURCE_REGBERRY_2026, verifiedAt: VERIFIED_AT }
  ]
}
